import { FETCH_EVENTS_REQUEST, GET_EVENTS, EVENTS_ERROR } from '../ActionTypes';

const initialState = {
    events: [],
    loading: true,
    error: '',
};

const eventReduction = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EVENTS_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_EVENTS:
            return {
                events: action.payload,
                loading: false,
                error: '',
            };
        case EVENTS_ERROR:
            return {
                events: [],
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default eventReduction;
